import React from "react";
import { numberWithCommas } from "../constants";

const SummaryPlan = ({ totalPrice, type, qty, order }) => {
  return (
    <div className="flex flex-col w-full md:w-2/6 bg-white h-full border border-l-2 p-4 gap-10">
      <div className="flex flex-col gap-5">
        <div className="font-bold text-[24px]">Summary</div>
        {order ? <div>Order ID: {order}</div> : null}
      </div>
      <div className="font-bold text-[30px]">
        IDR {numberWithCommas(totalPrice)}
      </div>
      <div className="flex flex-col gap-4 justify-between">
        <div className="flex flex-row justify-between font-bold">
          <div>Product</div>
          <div>Price</div>
        </div>
        <div className="flex flex-row justify-between">
          <div className="flex flex-col">
            <div>Individual Plan Subscription - {type}</div>
            <span className="text-[12px] text-gray-400">
              {qty} {type == "Yearly" ? "years" : "months"}
            </span>
          </div>
          <div>IDR {numberWithCommas(totalPrice)}</div>
        </div>

        <div className="flex flex-row justify-between font-bold">
          <div>Subtotal</div>
          <div>IDR {numberWithCommas(totalPrice)}</div>
        </div>
      </div>
    </div>
  );
};

export default SummaryPlan;
